import { Injectable, signal } from '@angular/core';
import { AppContextMenuItem, AppContextMenuState } from '../components/app-context-menu/app-context-menu.models';

@Injectable({
  providedIn: 'root'
})
export class AppContextMenuService {
  private readonly stateSignal = signal<AppContextMenuState>({
    open: false,
    x: 0,
    y: 0,
    title: '',
    items: []
  });

  readonly state = this.stateSignal.asReadonly();

  openAt(event: MouseEvent, items: AppContextMenuItem[], title?: string): void {
    event.preventDefault();
    event.stopPropagation();

    if (!items.length) {
      this.close();
      return;
    }

    this.stateSignal.set({
      open: true,
      x: event.clientX,
      y: event.clientY,
      title,
      items
    });
  }

  close(): void {
    if (!this.stateSignal().open) {
      return;
    }

    this.stateSignal.set({
      open: false,
      x: 0,
      y: 0,
      title: '',
      items: []
    });
  }

  invoke(itemId: string): void {
    const state = this.stateSignal();
    const item = state.items.find((menuItem) => menuItem.id === itemId);
    if (!item || item.disabled) {
      return;
    }

    this.close();
    item.action();
  }
}
